<template>
  <nav class="main-nav">
    <router-link :to="{ name: 'Home' }">Project</router-link>
    <router-link :to="{ name: 'AddProject' }">Add New</router-link>
  </nav>
</template>
<script>
export default {};
</script>
<style>
.main-nav {
  text-align: center;
  margin: 40px auto;
}
.main-nav a {
  display: inline-block;
  text-decoration: none;
  margin: 0 10px;
  color: #999;
  font-size: 18px;
  padding: 10px;
}
a.router-link-exact-active {
  border-bottom: 2px solid #00ce89;
  padding-bottom: 4px;
}
</style>
